import { getAxiosClient } from "../../axios-client";
import {
  ChangeLoginBody, 
  ChangeLoginResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const changeLogin = async (
  body: ChangeLoginBody
) => {
  return await axiosClient.ax.put<ChangeLoginResponse>(
    "/Users/ChangeLogin",
    body
  );
};
